import React from 'react';
import MobileBottomSheet from './MobileBottomSheet';

const SHAPES = [
  { id: 'rectangle', label: 'Rechteck', method: 'addRectangle',
    icon: <svg viewBox="0 0 40 40" fill="currentColor" opacity="0.8"><rect x="4" y="8" width="32" height="24" rx="1"/></svg> },
  { id: 'roundedRect', label: 'Abgerundet', method: 'addRoundedRect',
    icon: <svg viewBox="0 0 40 40" fill="currentColor" opacity="0.8"><rect x="4" y="8" width="32" height="24" rx="8"/></svg> },
  { id: 'circle', label: 'Kreis', method: 'addCircle',
    icon: <svg viewBox="0 0 40 40" fill="currentColor" opacity="0.8"><circle cx="20" cy="20" r="15"/></svg> },
  { id: 'ellipse', label: 'Ellipse', method: 'addEllipse',
    icon: <svg viewBox="0 0 40 40" fill="currentColor" opacity="0.8"><ellipse cx="20" cy="20" rx="17" ry="11"/></svg> },
  { id: 'triangle', label: 'Dreieck', method: 'addTriangle',
    icon: <svg viewBox="0 0 40 40" fill="currentColor" opacity="0.8"><polygon points="20,5 36,35 4,35"/></svg> },
  { id: 'diamond', label: 'Raute', method: 'addDiamond',
    icon: <svg viewBox="0 0 40 40" fill="currentColor" opacity="0.8"><polygon points="20,4 36,20 20,36 4,20"/></svg> },
  { id: 'pentagon', label: 'Fünfeck', method: 'addPolygon',
    icon: <svg viewBox="0 0 40 40" fill="currentColor" opacity="0.8"><polygon points="20,4 37,16 31,35 9,35 3,16"/></svg> },
  { id: 'hexagon', label: 'Hexagon', method: 'addHexagon',
    icon: <svg viewBox="0 0 40 40" fill="currentColor" opacity="0.8"><polygon points="20,4 35,12 35,28 20,36 5,28 5,12"/></svg> },
  { id: 'octagon', label: 'Achteck', method: 'addOctagon',
    icon: <svg viewBox="0 0 40 40" fill="currentColor" opacity="0.8"><polygon points="14,4 26,4 36,14 36,26 26,36 14,36 4,26 4,14"/></svg> },
  { id: 'star', label: 'Stern', method: 'addStar',
    icon: <svg viewBox="0 0 40 40" fill="currentColor" opacity="0.8"><polygon points="20,4 24,15 36,15 27,22 30,34 20,27 10,34 13,22 4,15 16,15"/></svg> },
  { id: 'starBurst12', label: 'Explosion 12', method: 'addStarBurst12',
    icon: <svg viewBox="0 0 40 40" fill="currentColor" opacity="0.85"><polygon points="20,1 24,12 33,3 28,14 39,12 30,21 38,28 27,25 32,38 20,30 14,40 16,28 4,32 11,22 1,23 9,16 3,8 14,13 11,3 18,12"/></svg> },
  { id: 'starBurst16', label: 'Explosion 16', method: 'addStarBurst16',
    icon: <svg viewBox="0 0 40 40" fill="currentColor" opacity="0.85"><polygon points="20,1 23,11 28,3 27,13 36,7 31,15 39,14 33,21 38,27 30,25 35,35 27,30 28,39 21,32 19,40 16,32 9,38 11,28 2,32 8,23 1,20 9,18 3,11 11,13 8,5 15,12 14,2 18,11"/></svg> },
  { id: 'starBurst24', label: 'Explosion 24', method: 'addStarBurst24',
    icon: <svg viewBox="0 0 40 40" fill="currentColor" opacity="0.85"><polygon points="20,1 22,9 25,3 25,11 30,6 28,13 35,9 31,16 38,14 33,20 39,21 33,25 38,30 31,28 35,36 28,30 29,38 24,32 22,40 20,32 17,40 15,32 11,38 12,30 5,36 8,28 2,30 7,25 1,21 7,20 2,14 9,16 5,9 12,13 9,3 14,11 14,3 19,9"/></svg> },
  { id: 'heart', label: 'Herz', method: 'addHeart',
    icon: <svg viewBox="0 0 40 40" fill="currentColor" opacity="0.8"><path d="M20 35 C10 28 2 20 2 13 C2 7 7 3 13 3 C16 3 19 5 20 8 C21 5 24 3 27 3 C33 3 38 7 38 13 C38 20 30 28 20 35Z"/></svg> },
  { id: 'arrow', label: 'Pfeil', method: 'addArrowRight',
    icon: <svg viewBox="0 0 40 40" fill="currentColor" opacity="0.8"><polygon points="4,13 25,13 25,6 38,20 25,34 25,27 4,27"/></svg> },
  { id: 'cross', label: 'Kreuz', method: 'addCross',
    icon: <svg viewBox="0 0 40 40" fill="currentColor" opacity="0.8"><polygon points="15,4 25,4 25,15 36,15 36,25 25,25 25,36 15,36 15,25 4,25 4,15 15,15"/></svg> },
  { id: 'parallelogram', label: 'Parallelogramm', method: 'addParallelogram',
    icon: <svg viewBox="0 0 40 40" fill="currentColor" opacity="0.8"><polygon points="12,8 38,8 28,32 2,32"/></svg> },
  { id: 'trapezoid', label: 'Trapez', method: 'addTrapezoid',
    icon: <svg viewBox="0 0 40 40" fill="currentColor" opacity="0.8"><polygon points="10,8 30,8 38,32 2,32"/></svg> },
  { id: 'ring', label: 'Ring', method: 'addRing',
    icon: <svg viewBox="0 0 40 40" fill="none" stroke="currentColor" strokeWidth="5" opacity="0.8"><circle cx="20" cy="20" r="13"/></svg> },
  { id: 'bubble', label: 'Sprechblase', method: 'addBubble',
    icon: <svg viewBox="0 0 40 40" fill="currentColor" opacity="0.8"><path d="M20 4 C10 4 3 10 3 18 C3 26 10 32 18 32 L14 38 L22 32 C30 32 37 26 37 18 C37 10 30 4 20 4Z"/></svg> },
  { id: 'badge', label: 'Badge', method: 'addBadge',
    icon: <svg viewBox="0 0 40 40" fill="currentColor" opacity="0.8"><polygon points="20,3 23,10 28,4 28,12 35,10 31,17 38,20 31,23 35,30 28,28 28,36 23,30 20,37 17,30 12,36 12,28 5,30 9,23 2,20 9,17 5,10 12,12 12,4 17,10"/></svg> },
  { id: 'line', label: 'Linie', method: 'addLine',
    icon: <svg viewBox="0 0 40 40" fill="none" stroke="currentColor" strokeWidth="3" opacity="0.8"><line x1="6" y1="34" x2="34" y2="6"/></svg> },
];

export default function MobileShapesSheet({ isOpen, onClose, canvasManager }) {
  const handleAdd = (method) => {
    if (!canvasManager) return;
    if (typeof canvasManager[method] === 'function') {
      canvasManager[method]();
    }
    onClose();
  };

  return (
    <MobileBottomSheet isOpen={isOpen} onClose={onClose} title="Formen" height="40vh">
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>
        {SHAPES.map((shape) => (
          <button
            key={shape.id}
            onClick={() => handleAdd(shape.method)}
            style={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px',
              padding: '10px 4px', border: '1px solid var(--selenny-border)', borderRadius: '10px',
              background: 'var(--selenny-surface)', cursor: 'pointer',
              WebkitTapHighlightColor: 'transparent',
              color: 'var(--selenny-text)',
            }}
          >
            <div style={{ width: 32, height: 32 }}>{shape.icon}</div>
            <span style={{ fontSize: '10px', opacity: 0.6, lineHeight: 1.2, textAlign: 'center' }}>{shape.label}</span>
          </button>
        ))}
      </div>
    </MobileBottomSheet>
  );
}
